import React, {useState} from 'react';
import './style.scss';
import {ModalPopup} from "../ModalPopup/ModalPopup.jsx";
import Dropdown from "../Dropdown/index.js";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {isRTL} from "../../../services/userModel.js";

const CourierShiftControlCentersPopup = ({isOpen, onClose, controlCenters, controlCenter, setControlCenter}) => {
    const {t} = useTranslation();
    const [selectedControlCenter, setSelectedControlCenter] = useState(controlCenter);
    const getValue = () => {
        if(controlCenter) return '';
        const cc = controlCenters.find(cc => cc.key === selectedControlCenter);
        if(!cc) return '';
        return cc.value;
    }

    const onSave = () => {
        setControlCenter(selectedControlCenter)
    }

    return (
        <ModalPopup
            containerModalClass={'courierShiftControlCentersPopupContainer'}
            isOpen={isOpen}
            onClose={onClose}
            content={(
                <div className={classNames('popupContainer courierShiftControlCentersPopup', {courierShiftControlCentersPopupRtl: isRTL()})}>
                    <div className={'header'}>{t("shifts.SELECT_CONTROL_CENTER")}</div>
                    <Dropdown
                        isCanBeEmpty
                        value={getValue()}
                        values={controlCenters}
                        onSelect={(data) => setSelectedControlCenter(data.key)}
                    />
                    <div className={'buttons'}>
                        <button className={"btn confirm"} onClick={onSave}>
                            {t("basic.SAVE_BUTTON")}
                        </button>
                        <button className={"btn denied"} onClick={onClose}>
                            {t("basic.CLOSE_BUTTON")}
                        </button>
                    </div>
                </div>
            )}
        />
    )
}

export default CourierShiftControlCentersPopup;
